<div class="cout-decoupage-portion cursorHelp" *ngIf="display()" title="coût unitaire total des plats pour '{{cellule.libelleDecoupageRepas.toUpperCase()}}'" >
  <i class="fas fa-coins fa-xs mg-r-5"></i>{{cellule.coutUnitaireTotal | currency:'EUR':'symbol':'1.4-4'}}
</div>
